import gsap from 'gsap'

export default {
  name: 'AccordionModule',
  data() {
    return {
      open: [],
    }
  },
  methods: {
    toggleQuestion(id) {
      const index = this.open.indexOf(id)

      if (index > -1) {
        this.open = []
      } else {
        this.open = [id]
      }
    },
    onEnter(el, done) {
      gsap.set(el, { height: 'auto', opacity: 1 })
      gsap.from(el, { height: 0, opacity: 0, duration: 0.5, onComplete: () => done() })
    },
    onLeave(el, done) {
      gsap.to(el, { height: 0, opacity: 0, duration: 0.5, onComplete: () => done() })
    },
  },
}
